import React, { useRef, useState } from "react"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import PatientCountCell from '../../../components/patient-count-cell/PatientCountCell'
import AHMIS, { API_URL } from "../../../api/api";
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import AddAlertMessage from "../../../components/alert/Alert";
import ReportHeader from "../component/report-header/ReportHeader";
import MessageBlock from "../../admin/components/message-block/MessageBlock";

const JesthaNagrikSewaReport = () => {

  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.jesthanagarikReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });
  };

  return (
    <>
      <ReportHeader
        title="जेष्ठ नागरिक सेवा प्रतिबेदन"
        getReportData={getReportData}
        reportData={Boolean(tableData)}
        printComponentRef={printComponentRef}

      />
      {tableData ? (
        <>
          <Box ref={printComponentRef}>
            <TableContainer classes={{ root: "fixed-head-table-container" }}  >
              <Typography variant="body1" className="report-heading">जेष्ठ नागरिक सेवा प्रतिवेदन</Typography>
              <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Jestha Nagrik Sewa">
                <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                  <TableRow>
                    <TableCell rowSpan={3}>सेवाको प्रकार अनुसार सेवा लिएको विवरण</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={3}>स्नेहन </TableCell>
                    <TableCell colSpan={3}>स्वेदन</TableCell>
                    <TableCell colSpan={3}>रसायन औषधि /तेल</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>महिला </TableCell>
                    <TableCell>पुरूष </TableCell>
                    <TableCell>अन्य </TableCell>
                    <TableCell>महिला </TableCell>
                    <TableCell>पुरूष </TableCell>
                    <TableCell>अन्य </TableCell>
                    <TableCell>महिला </TableCell>
                    <TableCell>पुरूष </TableCell>
                    <TableCell>अन्य </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody classes={{ root: "align-center" }}>
                  <TableRow>
                    <TableCell>नयाँ सेवाग्राही संख्या</TableCell>
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["1"]?.FEMALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["1"]?.MALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["1"]?.OTHER} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["2"]?.FEMALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["2"]?.MALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["2"]?.OTHER} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["3"]?.FEMALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["3"]?.MALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.NEW_PATIENT["3"]?.OTHER} />
                  </TableRow>
                  <TableRow>
                    <TableCell>पुनरावृत सेवाग्राही संख्या</TableCell>
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["1"]?.FEMALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["1"]?.MALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["1"]?.OTHER} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["2"]?.FEMALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["2"]?.MALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["2"]?.OTHER} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["3"]?.FEMALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["3"]?.MALE} />
                    <PatientCountCell data={tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["3"]?.OTHER} />
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box mt={2}>
              <TableContainer classes={{ root: "fixed-head-table-container" }}  >
                <Typography variant="body1" className="report-heading">उमेर अनुसार सेवा प्रतिबेदन</Typography>
                <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Jestha Nagrik Sewa">
                  <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                    <TableRow>
                      <TableCell rowSpan={3}>उमेर समूह वर्ष/सेवा</TableCell>
                      <TableCell colSpan={3}>नयाँ सेवाग्राही मात्र</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>रसायन औषधि /तेल</TableCell>
                      <TableCell>स्नेहन </TableCell>
                      <TableCell>स्वेदन </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody classes={{ root: "align-center" }}>
                    <TableRow>
                      <TableCell>६० देखि ६९</TableCell>
                      <PatientCountCell data={tableData?.ageGroupService?.["60-69"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.["60-69"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.["60-69"]?.["3"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>७० देखि ७९</TableCell>
                      <PatientCountCell data={tableData?.ageGroupService?.["70-79"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.["70-79"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.["70-79"]?.["3"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>८० देखि ८४</TableCell>
                      <PatientCountCell data={tableData?.ageGroupService?.["80-84"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.["80-84"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.["80-84"]?.["3"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>=८५ वर्ष</TableCell>
                      <PatientCountCell data={tableData?.ageGroupService?.[">=85"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.[">=85"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupService?.[">=85"]?.["3"]} />
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box mt={2}>
              <TableContainer classes={{ root: "fixed-head-table-container" }}  >
                <Typography variant="body1" className="report-heading">सेवाग्राही अनुसारको विवरण</Typography>
                <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Jestha Nagrik Sewa">
                  <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                    <TableRow>
                      <TableCell colSpan={2}>सेवाग्राही अनुसारको विवरण</TableCell>
                      <TableCell>नयाँ</TableCell>
                      <TableCell>पुनरावृत</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody classes={{ root: "align-center" }}>
                    <TableRow>
                      <TableCell rowSpan={4}>जेष्ठ नागरिक सेवाग्राही संख्या</TableCell>
                      <TableCell>महिला</TableCell>
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.NEW_PATIENT?.FEMALE} />
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.FEMALE} />
                    </TableRow>
                    <TableRow>
                      <TableCell>पुरुष</TableCell>
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.NEW_PATIENT?.MALE} />
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.MALE} />
                    </TableRow>
                    <TableRow>
                      <TableCell>अन्य</TableCell>
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.NEW_PATIENT?.OTHER} />
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.OTHER} />
                    </TableRow>
                    <TableRow>
                      <TableCell>जम्मा</TableCell>
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.NEW_PATIENT?.TOTAL} />
                      <PatientCountCell data={tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.TOTAL} />
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default JesthaNagrikSewaReport;